import React from 'react';
import {
  Modal,
  InputNumber,
  Input,
  Button,
  Form,
  Typography,
  Row,
  Col,
  Statistic
} from 'antd';
import { debtService, Debt } from '../../services/debtService';
import { DollarOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

interface Props {
  debt: Debt;
  onClose: () => void;
  onPaid: () => void;
  debts?: Debt[];
}

const DebtPaymentModal: React.FC<Props> = ({ debt, onClose, onPaid, debts }) => {
  const [form] = Form.useForm();
  const [selectedDebtId, setSelectedDebtId] = React.useState<number>(debt.id);
  const debtList = debts && debts.length > 0 ? debts : [debt];
  const selectedDebt = debtList.find(d => d.id === selectedDebtId) || debt;
  const remain = selectedDebt.debt_amount - selectedDebt.paid_amount;

  React.useEffect(() => {
    // Nếu selectedDebtId không còn trong danh sách nợ còn lại, tự động chọn khoản nợ đầu tiên
    if (debtList.length > 0 && !debtList.some(d => d.id === selectedDebtId)) {
      setSelectedDebtId(debtList[0].id);
    }
  }, [debtList, selectedDebtId]);

  const handleFinish = async (values: any) => {
    await debtService.createPayment(selectedDebt.id, values.amount, values.note);
    onPaid();
  };

  return (
    <Modal open onCancel={onClose} footer={null} title={<Title level={4}>Thanh toán công nợ</Title>} width={600}>
      {debtList.length > 1 && (
        <Form.Item label={<Text strong>Chọn khoản nợ</Text>} style={{ marginBottom: 16 }}>
          <select
            value={selectedDebtId}
            onChange={e => setSelectedDebtId(Number(e.target.value))}
            style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #d9d9d9' }}
          >
            {debtList.map(d => (
              <option key={d.id} value={d.id}>
                Nợ #{d.id} - {d.debt_amount.toLocaleString('vi-VN')} (Còn lại: {(d.debt_amount - d.paid_amount).toLocaleString('vi-VN')})
              </option>
            ))}
          </select>
        </Form.Item>
      )}
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={12}>
          <Statistic
            title="Còn lại"
            value={remain}
            prefix={<ExclamationCircleOutlined />}
            valueStyle={{ color: '#ff4d4f' }}
            formatter={v => v?.toLocaleString('vi-VN')}
          />
        </Col>
        <Col span={12}>
          <Statistic
            title="Số nợ ban đầu"
            value={selectedDebt.debt_amount}
            prefix={<DollarOutlined />}
            valueStyle={{ color: '#faad14' }}
            formatter={v => v?.toLocaleString('vi-VN')}
          />
        </Col>
      </Row>
      <Form form={form} layout="vertical" onFinish={handleFinish} initialValues={{ amount: remain }}>
        <Form.Item label={<Text strong>Số tiền thanh toán</Text>} name="amount" rules={[{ required: true, message: 'Nhập số tiền!' }, { type: 'number', min: 1, max: remain, message: `Tối đa ${remain.toLocaleString('vi-VN')}` }]}> 
          <InputNumber min={1} max={remain} style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item label={<Text strong>Ghi chú</Text>} name="note">
          <Input.TextArea rows={2} maxLength={200} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" block size="large">Thanh toán</Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DebtPaymentModal; 